import {find, pipe} from '@yandex-delivery/utils'

// TODO: переделать на конфиг
const phoneSubstitutionList: [string | RegExp, string][] = [
  ['0', '+972'],
  ['8', '+7'],
]

export const getDigits = (phone: string) => phone?.replace(/\D/g, '')

/**
 * Заменяет у телефона префикс согласно конфигу.
 * Прим.: 050 000 0000 -> +972 50 000 0000
 */
export const phoneLocalToGlobal = (phone?: string) =>
  phone &&
  pipe(
    phoneSubstitutionList,
    // находим пару с подходящим префиксом
    find(([fst]) => (typeof fst === 'string' ? phone.startsWith(fst) : fst.test(phone))),
    // если нашли, меняем его. Если нет, ничего не делаем
    pair => (!!pair ? phone.replace(...pair) : phone),
  )
